<template>
  <div class="go-in">
    <banner :img="require('@/assets/img/bgtop.jpg')" title="走进益华通盛" :height="200" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <!-- 公司简介 -->
        <div class="content-summary">
          <div class="summary-left">
            <h2 class="title">公司简介</h2>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              深圳益华通盛能源动力科技有限公司（简称"益华通盛"），是一家致力于新能源领域科技创新的高科技企业，
              专注于为全球客户提供高效、智能的电池管理系统（BMS）解决方案。自成立以来，我们始终秉持"创新驱动
              发展，科技引领未来"的理念，不断推动新能源技术的革新与应用。
              <br><br>主营业务：<br>
              益华通盛的主营业务涵盖多个新能源领域，包括但不限于叉车BMS、船舶BMS、电摩BMS、重卡BMS、工商储能
              BMS以及便携手储能BMS等。我们凭借深厚的技术积累和丰富的行业经验，为各类新能源设备提供精准、可靠
              的电池管理解决方案。
              <br><br>科技创新：<br>
              益华通盛拥有一支由行业专家、资深工程师和技术精英组成的研发团队，致力于新能源技术的持续创新和突破。
              我们不断引入先进的设计理念和技术手段，优化电池管理系统的性能和功能，确保我们的产品始终处于行业领先
              地位。同时，我们还积极与国内外知名高校、科研机构和企业开展产学研合作，共同推动新能源技术的研发
              和应用。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt="公司简介" />
          </div>
        </div>

        <el-divider class="divider-custom">
          <i class="el-icon-star-on"></i>
        </el-divider>

        <!-- 发展历程 -->
        <div class="content-course">
          <div class="section-header">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper" class="timeline-swiper">
              <swiper-slide v-for="(item, index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne, one) in item" :key="one">
                    <div class="item-top" :class="{ 'reverse-order': one % 2 === 1 }"></div>
                    <el-divider class="timeline-divider">
                      <i class="el-icon-date"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{ 'reverse-order': one % 2 === 1 }">
                      <div class="item-bottom-content">
                        <p class="event-content">{{ courseOne.Content }}</p>
                        <p class="event-year">{{ courseOne.Year }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <!-- 企业文化 -->
        <div class="content-culture">
          <div class="section-header">
            <h3>企业文化</h3>
            <p>CULTURE</p>
            <div class="border"></div>
          </div>
          <p class="culture-main">我们只专注一件事情——能源安全</p>
          <ul class="culture-values">
            <li>确保电池无重大安全事故</li>
            <li>确保电池BMS无大面积返工</li>
            <li>确保电池BMS材料及设备无伪劣产品</li>
            <li>确保电池BMS留下痕迹、异常过程可追溯</li>
          </ul>
        </div>

        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="section-header">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor, index) in honors" :key="index" class="honor-item">
              <img
                :src="honor.image"
                :alt="honor.title"
                @click="openHonorDialog(honor.image)"
              />
              <p>{{ honor.title }}</p>
            </li>
          </ul>
        </div>

        <!-- 团队风采 -->
        <div class="content-team">
          <div class="section-header">
            <h3>团队风采</h3>
            <p>TEAM</p>
            <div class="border"></div>
          </div>
          <el-carousel :interval="4000" type="card" height="400px" indicator-position="outside">
            <el-carousel-item v-for="(item, index) in teamImages" :key="index">
              <img class="team-image" :src="item" alt="团队风采" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="section-header">
            <h3>合作伙伴</h3>
            <p>PARTNERS</p>
            <div class="border"></div>
          </div>
          <ul class="partner-img">
            <li v-for="(partner, index) in partners" :key="index">
              <img :src="partner.image" :alt="partner.name" />
            </li>
          </ul>
        </div>

        <!-- 荣誉弹窗 -->
        <el-dialog
          :visible.sync="dialogTableVisible"
          width="60%"
          top="5vh"
          class="honor-dialog"
          :modal-append-to-body="false"
        >
          <img :src="dialogUrl" alt="荣誉证书" style="width: 100%; height: auto;" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      courseList: [
        [
          { Content: "公司成立，专注于新能源领域", Year: "2010" },
          { Content: "推出首款BMS产品，获得客户认可", Year: "2012" },
          { Content: "获得A轮融资，扩大研发团队", Year: "2014" },
        ],
        [
          { Content: "设立深圳总部，建设生产基地", Year: "2016" },
          { Content: "发布新一代智能BMS系统", Year: "2018" },
          { Content: "获得行业最佳创新奖", Year: "2020" },
        ],
        [
          { Content: "完成B轮融资，加速全球化布局", Year: "2022" },
          { Content: "与多家大型企业建立战略合作关系", Year: "2023" },
          { Content: "自研新能源BMS和EMS主板，成立子公司开发和研究", Year: "2025" },
        ],
      ],
      partners: [
        { image: require('../assets/img/partner1.png'), name: "合作伙伴1" },
        { image: require('../assets/img/partner2.png'), name: "合作伙伴2" },
        { image: require('../assets/img/partner3.png'), name: "合作伙伴3" },
        { image: require('../assets/img/partner4.png'), name: "合作伙伴4" },
      ],
      honors: [
        { image: require('../assets/img/honor.png'), title: "高新技术企业" },
        { image: require('../assets/img/honor.png'), title: "质量管理体系认证" },
        { image: require('../assets/img/honor.png'), title: "环保认证" },
        { image: require('../assets/img/honor.png'), title: "安全生产许可证" },
      ],
      teamImages: [
        require('../assets/img/team1.png'),
        require('../assets/img/team2.png'),
        require('../assets/img/team3.png'),
      ],
      loading: false,
      dialogTableVisible: false,
      dialogUrl: "",
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
    this.loading = false; // 直接关闭loading
  },
  methods: {
    openHonorDialog(imageUrl) {
      this.dialogUrl = imageUrl;
      this.dialogTableVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.go-in {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;

  .section {
    width: 100%;

    &-content {
      max-width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);

      .section-header {
        text-align: center;
        margin: 40px 0 30px;

        h3 {
          font-size: 32px;
          color: #1a75bb;
          margin: 0 0 10px;
          font-weight: 600;
        }

        p {
          font-size: 18px;
          color: #666;
          margin: 0 0 15px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .border {
          border-bottom: 2px solid #1a75bb;
          width: 100px;
          margin: 15px auto 5px;
        }
      }

      .content-summary {
        display: flex;
        gap: 40px;
        padding: 40px 20px;
        align-items: center;

        .summary-left {
          flex: 1;
          min-width: 0; // 防止flex项溢出

          .title {
            font-size: 28px;
            color: #e13834;
            margin-bottom: 10px;
            font-weight: 600;
          }

          .eTitle {
            font-size: 18px;
            color: #e13834;
            margin-bottom: 25px;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .content {
            color: #333;
            font-size: 16px;
            line-height: 1.8;
            text-align: justify;
          }
        }

        .summary-right {
          flex: 0 0 400px;
          height: 350px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          transition: transform 0.3s ease;

          &:hover {
            transform: translateY(-5px);
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .divider-custom {
        margin: 40px 0;
        background-color: #e9ecef;

        ::v-deep .el-divider__text {
          background-color: #fff;
          padding: 0 20px;
          font-size: 20px;
          color: #1a75bb;
        }
      }

      // 发展历程
      .content-course {
        padding: 20px 0;

        .course-time {
          width: 100%;
          margin: 20px auto;

          .timeline-swiper {
            width: 90%;
            margin: 0 auto;

            .time-show {
              width: 100%;
              display: flex;
              justify-content: center;

              .time-show-item {
                width: 300px;
                height: 300px;
                margin: 0 10px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .item-top,
                .item-bottom {
                  height: 140px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &.reverse-order {
                    order: 1;
                  }
                }

                .item-bottom {
                  .item-bottom-content {
                    background-color: #1a75bb;
                    padding: 20px;
                    border-radius: 8px;
                    text-align: center;
                    color: #fff;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .event-content {
                      font-size: 14px;
                      margin-bottom: 10px;
                      line-height: 1.5;
                    }

                    .event-year {
                      font-size: 18px;
                      font-weight: bold;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .timeline-divider {
        margin: 5px 0;

        ::v-deep .el-divider__text {
          background-color: #1a75bb;
          color: #fff;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      // 企业文化
      .content-culture {
        padding: 50px 0;
        background: linear-gradient(135deg, #f5f7fa 0%, #e4edf9 100%);
        text-align: center;

        .culture-main {
          font-size: 28px;
          color: #1a75bb;
          font-weight: 600;
          margin: 30px 0;
        }

        .culture-values {
          max-width: 800px;
          margin: 0 auto;
          text-align: left;
          padding-left: 20%;

          li {
            font-size: 18px;
            color: #333;
            line-height: 2.2;
            list-style-type: disc;
            margin-left: 20px;
          }
        }
      }

      // 公司荣誉
      .content-honor {
        padding: 50px 0;

        .honor-show {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 30px;
          width: 100%;
          margin: 30px auto;
          padding: 0 20px;

          .honor-item {
            text-align: center;
            transition: transform 0.3s ease;
            cursor: pointer;
            padding: 15px;
            border-radius: 8px;
            border: 1px solid #e9ecef;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 20px rgba(0,0,0,0.1);
            }

            img {
              width: 100%;
              height: 200px;
              object-fit: contain;
              margin-bottom: 10px;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }

            p {
              font-size: 16px;
              color: #333;
              margin: 0;
            }
          }
        }
      }

      // 团队风采
      .content-team {
        padding: 50px 20px;

        ::v-deep .el-carousel__container {
          width: 90%;
          margin: 0 auto;
        }

        .team-image {
          height: 400px;
          width: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }

      // 合作伙伴
      .content-partner {
        padding: 50px 0;

        .partner-img {
          width: 90%;
          margin: 20px auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 30px;
          padding: 0 20px;

          li {
            list-style: none;
            text-align: center;
            transition: transform 0.3s ease;

            &:hover {
              transform: scale(1.1);
            }

            img {
              width: 100%;
              height: 100px;
              object-fit: contain;
              border: 1px solid #dee2e6;
              border-radius: 8px;
              padding: 10px;
              background-color: #fff;
              transition: all 0.3s ease;

              &:hover {
                border-color: #1a75bb;
                box-shadow: 0 4px 12px rgba(26, 117, 187, 0.2);
              }
            }
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 992px) {
  .go-in .section-content {
    padding: 10px;
  }

  .content-summary {
    flex-direction: column;
    padding: 20px 10px !important;
  }

  .summary-right {
    flex: none !important;
    width: 100% !important;
    height: 250px !important;
    margin-top: 20px !important;
  }

  .content-culture .culture-values {
    padding-left: 10% !important;
  }
}

@media (max-width: 768px) {
  .content-summary .summary-left .title {
    font-size: 24px;
  }

  .section-header h3 {
    font-size: 26px !important;
  }

  .section-header p {
    font-size: 16px !important;
  }

  .content-honor .honor-show {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)) !important;
  }
}

@media (max-width: 576px) {
  .content-summary .summary-left .content {
    font-size: 14px;
  }

  .content-culture .culture-values {
    padding-left: 5% !important;
  }

  .content-culture .culture-values li {
    font-size: 16px !important;
  }

  .content-honor .honor-show {
    grid-template-columns: 1fr !important;
    padding: 0 10px !important;
  }
}
</style>